/**
 * iOS/iPadOS require getUserMedia inside a direct user gesture (tap/click).
 * Auto-starting the mic after AI audio finishes is blocked on these devices.
 */
export const isAppleDevice = () => {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;

  // iPadOS 13+ may report as MacIntel with touch points
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    return true;
  }

  return false;
};

export const requiresMicUserGesture = () => isAppleDevice();

export const getMicAudioConstraints = () => {
  const base = {
    echoCancellation: true,
    noiseSuppression: true,
    // AGC on iOS can duck speaker output while the mic session is active.
    autoGainControl: !requiresMicUserGesture(),
  };

  if (requiresMicUserGesture()) {
    return base;
  }

  return { ...base, sampleRate: 16000 };
};

export const getSupportedRecorderMimeType = () => {
  if (typeof MediaRecorder === "undefined") return null;

  const types = [
    "audio/webm;codecs=opus",
    "audio/mp4",
    "audio/aac",
    "audio/webm",
  ];

  for (const type of types) {
    if (MediaRecorder.isTypeSupported(type)) return type;
  }

  return null;
};
